import {useEffect} from 'react';
import {useParams} from 'react-router-dom';

import {Header, Tabs} from '@/components';
import type {TabItem} from '@/types';
import {logger} from '@/utils/logger';

import AvailabilitySettings from './AvailabilitySettings';
import KycSettings from './KycSettings';
import ReferralSettings from './ReferralSettings';
import Summary from './Summary';
import useCountryUpdate from './useCountryUpdate';

const Details = () => {
  const params = useParams();
  const countryCode = params?.countryCode || '';
  const {isLoading, item, handleUpdate, fetchItem} = useCountryUpdate();

  useEffect(() => {
    if (countryCode) {
      // `fetchItem` try/catches into showErrorMessage, so this only fires if
      // that reporting itself threw. Attached because an unhandled rejection
      // would leave the referral-settings tab editing an empty country; dev
      // logger rather than a second toast, since a toast is what just failed.
      fetchItem(countryCode).catch(logger.error);
    }
  }, [countryCode, fetchItem]);

  const tabs: TabItem[] = [
    {
      id: 'general',
      title: 'General',
      content: <Summary item={item} />,
    },

    {
      id: 'availability',
      title: `Availability`,
      content: <AvailabilitySettings handleSave={handleUpdate} item={item} />,
    },

    {
      id: 'referral-settings',
      title: `Referral Settings`,
      content: <ReferralSettings handleSave={handleUpdate} item={item} />,
    },

    {
      id: 'kyc',
      title: `KYC`,
      content: <KycSettings handleSave={handleUpdate} item={item} />,
    },
  ];
  return (
    <main className="mt-10 mb-5 mx-4 md:mx-10">
      <Header title={item?.name || ''} />
      <Tabs key={isLoading?.toString()} tabs={tabs} queryKey={'tab'} />
    </main>
  );
};
export default Details;
